import { configurationServiceInstance } from "services/ConfigurationService";

export const getFilteredRelationsKeys = (relationKeys: string[]) =>
  relationKeys.filter((key) =>
    configurationServiceInstance.listOfRelationsKeys.some((relationFromConf) => key.includes(relationFromConf))
  );
